import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../../../../util/cookie/cookies";
export interface Props {scroll : any}
export const Section6:React.FC<Props>= ({scroll}) => {
    const lang = getCookie('HYUNDAILANG')
    const {t} = useTranslation()
    const navigate = useNavigate()
    return(
        <>
        <section className="mainSection_6">
            <div>
                <div className="left">
                    <div ref={(e)=>scroll.current[5]=e}>
                        {lang === 'kr' ?
                        <h2>
                            <span>현대앤테크와 리페르의</span>
                            기술력으로 탄생한 제품들
                        </h2>
                        :
                        <h2>
                            Products born from the technology of Hyundai & Tech and LIEBHERR
                        </h2>
                        }
                        <p>{t("main_section_35")}</p>
                    </div>
                    <div className="arrowBox">
                        <button className="left"></button>
                        <button className="right"></button>
                    </div>
                </div>
                <div className="right">
                    <div className="imgBox">
                        <img src="/assets/images/mainSection_6.png" alt="현대앤테크와 리페르의 기술력으로 탄생한 제품들"/>
                        <button className="moreViewBtn" onClick={()=>navigate('/prCenter/news?type=ALL')}>detail view</button>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}